/* FAQ accordion. One open at a time; clicking the open row closes it.
   Height animates via grid-template-rows 0fr↔1fr (CSS), so this only
   flips aria-expanded. */
(function () {
  function init(root) {
    /* The product page loads this file for its own accordion, so on a page
       that also has the FAQ section the script runs twice. Without this guard
       every button would bind two listeners and toggle itself straight back. */
    if (root.dataset.faqReady === 'true') return;
    root.dataset.faqReady = 'true';

    var buttons = Array.prototype.slice.call(root.querySelectorAll('.faq__q'));

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var wasOpen = button.getAttribute('aria-expanded') === 'true';
        buttons.forEach(function (other) {
          other.setAttribute('aria-expanded', 'false');
        });
        button.setAttribute('aria-expanded', wasOpen ? 'false' : 'true');
      });
    });
  }

  document.querySelectorAll('[data-faq]').forEach(init);

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-faq]').forEach(init);
  });
})();
